import React, { Component } from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import PropTypes from 'prop-types'
import axios from "../../axios";
import Alert from "react-s-alert";
import qs from 'qs';
import DatePicker from "react-datepicker/es";
import moment from "moment";

class SetWaktu extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dateStart:"",
            dateNowStart:"",
            dateEnd:"",
            dateNowEnd:"",
            exam_start_date_moment: null,
            exam_end_date_moment: null,
            exam_end_date:this.props.endOld,
            exam_start_date:this.props.startOld,
            isLoading:false
        }

        this.handleSubmit = this.handleSubmit.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.handleSubmitSetWaktu = this.handleSubmitSetWaktu.bind(this);
        this.handleDatepickerStartChange = this.handleDatepickerStartChange.bind(this);
        this.handleDatepickerEndChange = this.handleDatepickerEndChange.bind(this);
    }

    toggleModal() {
        this.props.toggleModal()
    }

    handleSubmit() {
        this.props.handleSubmit()
    }


    handleChange(event) {

        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        })

    }

    handleDatepickerStartChange(date) {
        if (date !== null) {
            this.setState({
                exam_start_date_moment: date,
                exam_start_date: date.format("YYYY-MM-DD HH:mm") + ":00"
            });
        } else {
            this.setState({exam_start_date: ""});
        }
    }

    handleDatepickerEndChange(date) {
        if (date !== null) {
            this.setState({
                exam_end_date_moment: date,
                exam_end_date: date.format("YYYY-MM-DD HH:mm") + ":00"
            });
        } else {
            this.setState({exam_end_date: ""});
        }
    }

    handleSubmitSetWaktu() {

        this.setState({ isButtonLoading: true, modalShow: true });

        const url = '/setTimePlus'

        let newState = {
            user_id:localStorage.SISMART_USER_ID,
            exam_id:this.props.examId,
            start:this.state.exam_start_date,
            end:this.state.exam_end_date
        };
        console.log(newState);
        axios({
            method: "post",
            url: url,
            data: qs.stringify(newState)
        })

            .then(response => {
                const result = response.data;

                if (result.status) {
                    Alert.success(result.text);
                    this.setState({ isButtonLoading: false },() => {
                        this.props.toggleModal();
                    });
                } else {
                    if (Array.isArray(result.message)) {
                        result.text.map(item => {
                            Alert.error(item);
                            return true;
                        });
                    } else {
                        Alert.error(result.text);
                    }

                    this.setState({ isButtonLoading: false });
                }
            })

            .catch(error => {
                console.log(error);
                this.setState({ isButtonLoading: false });
                Alert.error("Gagal terhubung ke server!");
            });

        this.setState({ modalShow: false });
    }


    render() {
        return (
            <Modal isOpen={this.props.isShow} toggle={this.toggleModal} className="modal-primary">
                <ModalHeader toggle={this.toggleModal}>{this.props.modalHeaderText}</ModalHeader>
                <ModalBody>
                    <div className="form-group row">
                        <label className="col-md-4 form-control-label">
                            Tanggal Mulai
                        </label>
                        <div className="col-md-8">
                            <DatePicker
                                selected={this.state.exam_start_date_moment}
                                selectsStart
                                startDate={this.state.exam_start_date_moment}
                                endDate={this.state.exam_end_date_moment}
                                onChange={this.handleDatepickerStartChange}
                                dateFormat="DD-MM-YYYY HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={1}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-md-4 form-control-label">
                            Tanggal Berakhir
                        </label>
                        <div className="col-md-8">
                            <DatePicker
                                selected={this.state.exam_end_date_moment}
                                selectsEnd
                                startDate={this.state.exam_start_date_moment}
                                endDate={this.state.exam_end_date_moment}
                                onChange={this.handleDatepickerEndChange}
                                dateFormat="DD-MM-YYYY HH:mm"
                                showTimeSelect
                                timeFormat="HH:mm"
                                timeIntervals={1}
                            />
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.handleSubmitSetWaktu}>{this.props.modalSubmitText}</Button>{' '}
                    <Button color="secondary" onClick={this.toggleModal}>Batal</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

SetWaktu.propTypes = {
    modalHeaderText: PropTypes.string.isRequired,
    modalBodyText: PropTypes.string.isRequired,
    modalSubmitText: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    toggleModal: PropTypes.func.isRequired,
    examId: PropTypes.func.isRequired,
    startOld: PropTypes.func.isRequired,
    endOld: PropTypes.func.isRequired,
}

export default SetWaktu


// WEBPACK FOOTER //
// ./src/views/Exam/SetWaktu.js